import Grid from '@material-ui/core/Grid/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import backImage from '../src/imgs/bg2.jpg';
import Appbar from './Appbar';
import './index.css';
import Routes from './Routes';

const styles = theme => ({
    root: {
        width: '100%',
        height: '100vh',
        backgroundImage: `url(${backImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        [theme.breakpoints.down('sm')]: {
            // backgroundSize: 'cover',
            // backgroundPosition: [-100, -100]
            backgroundRepeat: 'repeat-y',
        },

        // background: '#000'
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginLeft: -12,
        marginRight: 20,
    },
    title: {
        // display: 'none',
        // [theme.breakpoints.up('sm')]: {
        display: 'block',
        width: 240,
        // background: '#000',
        // },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    mainContainer: {
        // flexDirection: 'row',
        // justifyContent: 'flex-end',
        // alignItems: 'center',
        flexGrow: 1,
        height: '91vh',
        padding: 4,
        paddingTop: 10,
    },
    // main: {
    //     margin: 300,
    // },
});

class PrimarySearchAppBar extends React.Component {
    render() {
        
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <Appbar />

                <Grid
                    direction="row"
                    justify="center"
                    alignItems="stretch"
                    container
                    className={classes.mainContainer}
                >
                    <Routes />
                </Grid>
            </div>
        );
    }
}

PrimarySearchAppBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withRouter(PrimarySearchAppBar));